export default {
      id: "i-cash-flow-usage",
      viewBox: "0 0 59 59",
      url: __webpack_public_path__ + "img/sprite.svg#i-cash-flow",
      toString: function () {
        return this.url;
      }
    }